import type { Track } from '@blackblack/shared';
import { api, errorMessage } from '../../lib/api';
import { patchEntity } from '../../lib/entities';
import { resetInfinite } from '../../lib/query';
import { useAuth } from '../../state/auth';
import { player } from '../../state/player';
import { useToast } from '../../state/toast';
import { useOpenSheet } from '../../components/ui/Sheet';
import { AddToPlaylistSheet } from './AddToPlaylistSheet';

export function useTrackActions() {
  const { requireAuth } = useAuth();
  const toast = useToast();
  const openSheet = useOpenSheet();

  return {
    async toggleLike(track: Track) {
      if (!requireAuth('Log in om nummers op te slaan')) return;
      const next = !track.liked;
      patchEntity('track', track.id, { liked: next });
      player.patchTrack(track.id, { liked: next });
      try {
        if (next) await api.post(`/music/tracks/${track.id}/like`);
        else await api.delete(`/music/tracks/${track.id}/like`);
        resetInfinite('liked-tracks');
        toast(next ? 'Toegevoegd aan Gelikete nummers' : 'Verwijderd uit Gelikete nummers');
      } catch (e) {
        patchEntity('track', track.id, { liked: !next });
        player.patchTrack(track.id, { liked: !next });
        toast(errorMessage(e), { tone: 'error' });
      }
    },
    addToPlaylist(track: Track) {
      if (!requireAuth('Log in om playlists te maken')) return;
      openSheet((close) => <AddToPlaylistSheet track={track} onClose={close} />);
    },
    queue(track: Track, mode: 'next' | 'end') {
      if (!track.streamUrl) return toast('Dit nummer is niet beschikbaar', { tone: 'error' });
      player.addToQueue(track, mode);
      toast(mode === 'next' ? 'Speelt hierna' : 'Toegevoegd aan wachtrij');
    },
    async share(track: Track) {
      const url = `${location.origin}/sound/${track.id}`;
      try {
        if (navigator.share) await navigator.share({ title: `${track.title} — ${track.artist.name}`, url });
        else {
          await navigator.clipboard.writeText(url);
          toast('Link gekopieerd');
        }
      } catch {
        /* cancelled */
      }
    },
  };
}
